import { Interpolation } from "@emotion/react"


export const scrollbarStyle = {
  scrollPaddingRight: "4px",
  '::-webkit-scrollbar': {
    width: "11px",
    height: "11px"
  },
  '::-webkit-scrollbar-track': {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '10px',
    margin: "2px",
    border: "3px solid transparent",
    backgroundClip: 'padding-box'
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '10px',
    border: "3px solid transparent",
    backgroundClip: 'padding-box'
  },
  '::-webkit-scrollbar-corner': {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '10px',
    width: '2px',
    height: '2px'
  }
}

const globalStyles: Interpolation<{}> = {
  "body, html": {
    overscrollBehaviorX: "none"
  },
  "textarea": {
    ...scrollbarStyle
  }
}

export default globalStyles
